import get from 'lodash/get';
import fragmentTypes from '@purple/match-graphql-schema/lib/schema/hs/fragmentTypes.json';
import { ApolloClient } from 'apollo-client';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { getJwtToken, signOut } from './containers/Authorization/actions';

const httpLink = new BatchHttpLink({ uri: process.env.API_URL });

const getToken = (store) => getJwtToken(get(store.getState(), 'current.viewer'));

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: fragmentTypes,
});

export default function getApolloClient(store) {
  const withAuth = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = getToken(store);
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      },
    };
  });
  const authFailed = onError(({ networkError }) => {
    if (networkError && networkError.statusCode === 401) {
      store.dispatch(signOut(store.getState().current.viewer));
    }
  });
  let localLink;
  /* istanbul ignore else */
  if (process.env.MOCK_GRAPHQL || process.env.NODE_ENV === 'test') {
    localLink = require('./createLocalLink').default(store); // eslint-disable-line global-require
  }
  const client = new ApolloClient({
    assumeImmutableResults: true,
    link: withAuth.concat(authFailed.concat(localLink || httpLink)),
    cache: new InMemoryCache({ fragmentMatcher, freezeResults: true }),
  });
  return client;
}
